/**
 * The Form frame's rules, with no DOM inside (piece 5; decisions 0242, 3060).
 * One frame draws every form, in a window body or in a page section, with the
 * same footer, the refusal inside it, the same guard on the ways out, the
 * Primary named for the act, and focus handed back to the opener. The window
 * shell and the page module both host it, and neither owns it.
 */

/** Where the frame stands: in a window's Body, or as a section of a page. */
export type FormFrameHost = 'window' | 'section';
export const FORM_FRAME_HOSTS: readonly FormFrameHost[] = ['window', 'section'];

/**
 * What a way out of the form does (decision 3061). 🔒 Escape, the `×`, Cancel
 * and Back close a form nobody typed in at once, and ask Leave Without Saving?
 * of one that holds anything typed. The three ways out stay one outcome.
 */
export type LeaveVerdict = 'close' | 'ask';

export function leaveVerdict(typed: boolean): LeaveVerdict {
  return typed ? 'ask' : 'close';
}

/**
 * Whether a navigation leaves the form's page (decision 3061). 🔨 A move
 * inside the page, a query or an anchor, is not a leave and is never held.
 */
export function leavesPage(currentPathname: string, nextPathname: string): boolean {
  return currentPathname !== nextPathname;
}
